import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  namespaced: true,
  state: {
    tabbarActive: 0,
    appletsId: ''
  },
  mutations: {
    changeTabbarActive(state, data) {
      state.tabbarActive = data
    },
    updateInfo(state, data) {
      state[data.name] = data.value
    },

    resetInfo(state, data) {
      state[data.name] = {}
    }
  },
  actions: {},
  modules: {}
})
